import { alpha, Box, Snackbar, Typography } from '@mui/material';
import React, { createContext, useMemo, useState } from 'react';

import icon from '../assets/images/notification-icon.svg';

import type { FC, ReactNode } from 'react';

export type SnackbarOption = {
  autoHideDuration?: number;
  title?: string;
  message?: string;
};

export type SnackbarContextValue = {
  showSnackbar: (option: SnackbarOption) => void;
};

const initialSnackbarOption = {
  autoHideDuration: 3000,
  title: undefined,
  message: undefined,
};

export const SnackbarContext = createContext<SnackbarContextValue>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  showSnackbar: () => {},
});

type SnackbarProviderProps = {
  children: ReactNode;
};

export const SnackbarProvider: FC<SnackbarProviderProps> = (props) => {
  const { children } = props;
  const [open, setOpen] = useState(false);
  const [currentOption, setCurrentOption] = useState<SnackbarOption>(initialSnackbarOption);

  const showSnackbar = (option: SnackbarOption): void => {
    setCurrentOption(option);
    setOpen(true);
  };

  const value = useMemo(() => ({ showSnackbar }), []);

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        sx={{
          backgroundColor: `${alpha('#474747', 0.93)}`,
          borderRadius: '13px',
          minWidth: 370,
          justifyContent: 'flex-start',
        }}
      >
        <Box p={1} sx={{ display: 'flex' }}>
          <img src={icon} alt="logo" />
          <Box pl={2} justifyContent="center">
            <Typography sx={{ color: 'common.white', fontWeight: 'bold' }}>{currentOption.title ?? ''}</Typography>
            <Typography variant="body2" sx={{ color: 'common.white' }}>
              {currentOption.message ?? ''}
            </Typography>
          </Box>
        </Box>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
